import styled from '@emotion/styled'

export const Cont = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))

export const ModalAction = styled.div((props)=>({
  padding: '1rem 1rem',
  textAlign: 'right',
}))

